import { Button } from "primereact/button";

import localeText from "../../../../locale";
import AppNoTextLogo from "../../../images/logo-color-notext.png";
import { isMobile } from "../../../../utilities/isMobile";
import { Link } from "react-router-dom";
import { dropShadow } from "@cloudinary/url-gen/actions/effect";
import { useState } from "react";
import { InputText } from "primereact/inputtext";

import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

const SecondaryBanner = () => {
  const [value, setValue] = useState("");
  return (
    <div className="grid grid-nogutter mt-8 shadow-2 border-round-md">
      <div
        className="grid grid-nogutter px-5 py-3 col-5 border-round-left-md"
        style={{ backgroundColor: "#3A7E54" }}
      >
        <div className="col flex align-items-center font-bold text-white text-2xl">
          Ganhe 15% de cashback na sua primeira compra
        </div>
        <div className="col flex justify-content-end align-items-center">
          <div>
            <img
              src={AppNoTextLogo}
              alt="app-logo"
              style={{ filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))" }}
              width={100}
            />
          </div>
        </div>
      </div>
      <div className="grid grid-nogutter align-items-center col-7" style={{ padding: "50px 40px" }}>
        {/* <InputText value={value} onChange={(e) => setValue(e.target.value)} /> */}
        <IconField iconPosition="left" className="col">
          <InputIcon className="pi pi-envelope px-2"></InputIcon>
          <InputText
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="pl-6 p-no-outline p-inputtext-sm w-full"
            placeholder="Search"
            style={{ backgroundColor: "#EBECF0", border: "2px solid #DFE1E6", height: "56px" }}
          />
        </IconField>
        <Button
          className="px-5 py-3 md:ml-3 font-semibold border-none"
          style={{ backgroundColor: "#FFC839", color: "#204C21" }}
          label={localeText("register")}
        ></Button>
        <div className="col-12 mt-2 text-xs" style={{ color: "#505F79" }}>
          Concordo com a{" "}
          <Link
            style={{ color: "#505F79" }}
            to="/privacy"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="underline"
          >
            {localeText("privacyPolicy")}
          </Link>{" "}
          e com os{" "}
          <Link style={{ color: "#505F79" }} to="/terms" className="underline">
            Termos de uso
          </Link>
          .
        </div>
      </div>
      {/* {isMobile === false && (
        <div className="flex flex-1 flex-column align-items-center justify-content-center bg-primary font-bold text-white lg:p-4 p-2 py-6 border-round gap-2">
          <p className="xl:text-4xl text-2xl text-center text-white">
            {localeText("secondaryBannerText")}
          </p>
          <Link to="/#plans" className="block">
            <Button className="xl:text-3xl lg:text-xl md:text-lg text-base">
              {localeText("secondaryBannerButtonText")}
            </Button>
          </Link>
        </div>
      )}
      <div className="banner-gradient-background flex flex-1 align-items-center justify-content-center font-bold text-white lg:p-4 p-2 py-6 border-round gap-4">
        <p className="xl:text-4xl lg:text-2xl text-xl xl:w-25rem w-15rem text-primary">
          {localeText("secondaryBannerText2")}
        </p>
        <img src={AppNoTextLogo} alt="app-logo" width={100} />
      </div> */}
    </div>
  );
};

export default SecondaryBanner;
